"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeShareLinksClient = void 0;
class FakeShareLinksClient {
    async trackCollectionShareLink(_collectionId) {
        return Promise.resolve();
    }
    async trackVideoShareLink(_videoId) {
        return Promise.resolve();
    }
}
exports.FakeShareLinksClient = FakeShareLinksClient;
//# sourceMappingURL=FakeShareLinksClient.js.map